import { BrandNoteTypeEnum } from "@nlc/shared-types";

import { Badge } from "@/components/badge";

import { InfoCircleIcon } from "./icons/InfoCircleIcon";
import { ShieldTickIcon } from "./icons/ShieldTickIcon";
import { SliderIcon } from "./icons/SliderIcon";

interface NoteTypeBadgeProps {
  readonly noteType: BrandNoteTypeEnum;
}

export function NoteTypeBadge({ noteType }: NoteTypeBadgeProps) {
  switch (noteType) {
    case BrandNoteTypeEnum.REQUIREMENTS: {
      return (
        <Badge
          className="bg-[#D92D20] border-[#B42318] text-white"
          isRounded
          size="large"
          variant="error"
        >
          <ShieldTickIcon />
          Requirements
        </Badge>
      );
    }
    case BrandNoteTypeEnum.PREFERENCES: {
      return (
        <Badge
          className="bg-[#FDB022] border-[#DC6803] text-white"
          isRounded
          size="large"
          variant="orange"
        >
          <SliderIcon />
          Preferences
        </Badge>
      );
    }
    case BrandNoteTypeEnum.CONTEXT_REFERENCES: {
      return (
        <Badge
          className="bg-[#1570EF] border-[#1849A9] text-white"
          isRounded
          size="large"
          variant="blue"
        >
          <InfoCircleIcon />
          Context & references
        </Badge>
      );
    }
    default: {
      return null;
    }
  }
}
